import React, { useState, useEffect, useContext, useCallback } from 'react';
import ApiService from '../../../services/ApiService';
import { AuthContext } from '../../../context/AuthContext';
import { Bars } from 'react-loader-spinner';
import $ from 'jquery';
import 'select2/dist/css/select2.min.css';
import 'select2';
import './Orders.css';

const Orders = () => {
    const { currentUser } = useContext(AuthContext);
    const [orders, setOrders] = useState([]);
    const [page, setPage] = useState(1);
    const [totalOrders, setTotalOrders] = useState(0);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState('');
    const [filters, setFilters] = useState([]);
    const [orderBy, setOrderBy] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState('');
    const [selectedEmployee, setSelectedEmployee] = useState('');
    const [selectedShipper, setSelectedShipper] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const [ordersResponse] = await Promise.all([
                    ApiService.getOrders(currentUser.access_token, page, search, filters, orderBy)
                ]);

                setOrders(ordersResponse.data.orders || []);
                setTotalOrders(ordersResponse.data.total);
            } catch (error) {
                console.error('Error fetching data', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [currentUser.access_token, page, search, filters, orderBy]);

    const handleFilterChange = useCallback((type, value, setSelected) => {
        setSelected(value);
        const newFilters = filters.filter(f => !f.startsWith(`${type}|`));
        if (value) {
            newFilters.push(`${type}|${value}`);
        }
        setFilters(newFilters);
    }, [filters]);

    useEffect(() => {
        const initializeSelect2 = (selector, apiCall, filterKey, setSelectedValue) => {
            $(selector).select2({
                ajax: {
                    transport: (params, success, failure) => {
                        const page = params.data.page || 1;
                        const search = params.data.search || '';

                        apiCall(currentUser.access_token, page, search)
                            .then(response => {
                                // Map the correct key from the API response
                                let results;
                                switch (filterKey) {
                                    case 'c.ID':
                                        results = response.data.customers;
                                        break;
                                    case 'e.ID':
                                        results = response.data.employees;
                                        break;
                                    case 's.ID':
                                        results = response.data.shippers;
                                        break;
                                    default:
                                        results = [];
                                }

                                success({
                                    results: results,
                                    pagination: {
                                        more: response.data.pagination.more
                                    }
                                });
                            })
                            .catch(error => {
                                failure(error);
                            });
                    },
                    data: (params) => ({
                        search: params.term,
                        page: params.page || 1
                    }),
                    delay: 250,
                    cache: true
                }
            }).on('select2:select', function (e) {
                const selectedValue = e.target.value;
                setSelectedValue(selectedValue);
                handleFilterChange(filterKey, selectedValue, setSelectedValue);
            });
        };

        // Initialize Select2 for Customers
        initializeSelect2('#CustomerID', ApiService.getCustomers, 'c.ID', setSelectedCustomer);

        // Initialize Select2 for Employees
        initializeSelect2('#EmployeeID', ApiService.getEmployees, 'e.ID', setSelectedEmployee);

        // Initialize Select2 for Shippers
        initializeSelect2('#ShipperID', ApiService.getShippers, 's.ID', setSelectedShipper);

        return () => {
            $('#CustomerID').select2('destroy');
            $('#EmployeeID').select2('destroy');
            $('#ShipperID').select2('destroy');
        };
    }, [currentUser.access_token, handleFilterChange]);

    const handleSort = (column) => {
        const direction = orderBy.find(o => o.startsWith(column))?.endsWith('desc') ? 'asc' : 'desc';
        setOrderBy([`${column}|${direction}`]);
    };

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
    };

    const handleReset = () => {
        setSearch('');
        setFilters([]);
        setOrderBy([]);
        setPage(1);
        setSelectedCustomer('');
        setSelectedEmployee('');
        setSelectedShipper('');

        $('#CustomerID').val(null).trigger('change');
        $('#EmployeeID').val(null).trigger('change');
        $('#ShipperID').val(null).trigger('change');
    };

    const getOrderByIcon = (column) => {
        const sortingDirection = orderBy.find(o => o.startsWith(column))?.split('|')[1];
        if (sortingDirection === 'asc') return '↑';
        if (sortingDirection === 'desc') return '↓';
        return '⇅';
    };

    const totalPages = Math.ceil(totalOrders / 10);
    const maxPageNumbers = 8;
    const startPage = Math.floor((page - 1) / maxPageNumbers) * maxPageNumbers + 1;
    const endPage = Math.min(startPage + maxPageNumbers - 1, totalPages);

    return (
        <div>
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                <h1 className="h3 mb-0 text-gray-800">Orders</h1>
                <a href="/" className="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                    <i className="fas fa-download fa-sm text-white-50"></i> Download
                </a>
            </div>
            <div className="row">
                <div className="col-xl-12 col-lg-12">
                    <div className="card shadow mb-4">
                        <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                        <h6 className="m-0 font-weight-bold text-primary">
                                Order Details
                            </h6>
                            <div className="dropdown">
                                <a
                                    className="dropdown-toggle"
                                    href="/"
                                    role="button"
                                    id="dropdownMenuLink"
                                    data-bs-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    <i className="fas fa-ellipsis-v fa-sm fa-fw text-gray-400"></i>
                                </a>
                                <ul
                                    className="dropdown-menu dropdown-menu-end shadow animated--fade-in"
                                    aria-labelledby="dropdownMenuLink"
                                >
                                    <li className="dropdown-header">Dropdown Header:</li>
                                    <li>
                                        <a className="dropdown-item" href="/">
                                            Action
                                        </a>
                                    </li>
                                    <li>
                                        <a className="dropdown-item" href="/">
                                            Another action
                                        </a>
                                    </li>
                                    <li>
                                        <hr className="dropdown-divider" />
                                    </li>
                                    <li>
                                        <a className="dropdown-item" href="/">
                                            Something else here
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {loading && (
                <div className="preloader-container">
                    <Bars
                        height="80"
                        width="80"
                        color="#000"
                        ariaLabel="loading"
                    />
                </div>
            )}
            <div className="table-container">
                <div className="d-flex jd-flex justify-content-evenly my-2">
                    <input
                        className='w25 mr-2'
                        type="text"
                        placeholder='Search'
                        value={search}
                        onChange={handleSearchChange}
                    />
                    <select
                        name="CustomerID"
                        id="CustomerID"
                        className="form-control mr-2 w20"
                        value={selectedCustomer}
                        onChange={handleSearchChange}
                    >
                        <option value="">All Customers</option>
                    </select>
                    <select
                        name="EmployeeID"
                        id="EmployeeID"
                        className="form-control mr-2 w20"
                        value={selectedEmployee}
                        onChange={handleSearchChange}
                    >
                        <option value="">All Employees</option>
                    </select>
                    <select
                        name="ShipperID"
                        id="ShipperID"
                        className="form-control mx-4 w20"
                        value={selectedShipper}
                        onChange={handleSearchChange}
                    >
                        <option value="">All Shippers</option>
                    </select>
                    <button className='btn btn-sm btn-dark w10 mx-4' onClick={handleReset}>RESET</button>
                </div>
                <table className="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th>Action</th>
                            <th>Order ID</th>
                            <th onClick={() => handleSort('o.OrderDate')}>
                                Order Date {getOrderByIcon('o.OrderDate')}
                            </th>
                            <th onClick={() => handleSort('c.CustomerName')}>
                                Customer {getOrderByIcon('c.CustomerName')}
                            </th>
                            <th onClick={() => handleSort('e.FirstName')}>
                                Employee {getOrderByIcon('e.FirstName')}
                            </th>
                            <th onClick={() => handleSort('s.ShipperName')}>
                                Shipper {getOrderByIcon('s.ShipperName')}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {orders.map((order) => (
                            <tr key={order.ID}>
                                <td>
                                    <button className='btn btn-sm btn-secondary'>View</button>
                                </td>
                                <td>{order.ID}</td>
                                <td>{order.OrderDate}</td>
                                <td>{order.CustomerName}</td>
                                <td>{order.EmployeeName}</td>
                                <td>{order.ShipperName}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <nav>
                    <ul className="pagination d-flex justify-content-center my-4">
                        <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                            <button className="page-link" onClick={() => setPage(1)}>First</button>
                        </li>
                        <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                            <button className="page-link" onClick={() => setPage(page - 1)}>Previous</button>
                        </li>
                        {Array.from({ length: endPage - startPage + 1 }, (_, index) => startPage + index).map(pageNumber => (
                            <li key={pageNumber} className={`page-item ${page === pageNumber ? 'active' : ''}`}>
                                <button className="page-link" onClick={() => setPage(pageNumber)}>
                                    {pageNumber}
                                </button>
                            </li>
                        ))}
                        <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                            <button className="page-link" onClick={() => setPage(page + 1)}>Next</button>
                        </li>
                        <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                            <button className="page-link" onClick={() => setPage(totalPages)}>Last</button>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    );
};

export default Orders;
